<div class="loader">
    <ng-lottie class="loading"  [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
</div>
